import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, inject } from '@angular/core';

import { Plan } from '@bytel/bytel-sales';
import { markdownTrilogy } from '@bytel/markdown-trilogy';

import { TrustHtmlPipe } from '@base/common/pipes/trustHtml.pipe';
import { ModalService } from '@base/common/services/modal.service';

import { CmsService } from '@services/cms.service';

import { PlanDetailsCms } from '@interfaces/directus-cms.interface';

import { ModalComponent } from '@shared/modal/modal.component';

import { CmsBlockComponent } from '../../../../common/components/cms-block/cms-block.component';
import { TextWithLinkDirective } from '../../../../common/directives/text-with-link.directive';
import { ObligationPipe } from '../../../../shared/pipes/obligation.pipe';
import { PriceComponent } from '../../../../trilogy/price/price.component';

@Component({
    selector: 'checkout-modal-offer-details',
    templateUrl: './modal-offer-details.component.html',
    styleUrl: 'modal-offer-details.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [PriceComponent, TextWithLinkDirective, CmsBlockComponent, ObligationPipe, TrustHtmlPipe],
})
export class ModalOfferDetailsComponent extends ModalComponent {
    @Input() public plan: Plan;
    @Input() public isLocked: boolean;
    @Input() public isOwned: boolean;
    @Input() public addPlan: () => void;
    @Output() public lockedToggleEvent = new EventEmitter<boolean>();

    public isDarwin: boolean = false;
    public title: string;
    public planDetails: PlanDetailsCms;
    public internationalCallsCmsBlockId: string = 'mobiles/banniere_forfaits-mobiles_destinations';
    public europeCmsBlockId: string = 'mobiles/banniere_forfaits-mobiles_destinations_europe';
    public showInternationalCallsList: boolean = false;
    public showEuropeSmsMmsList: boolean = false;
    public showEuropeAbroadList: boolean = false;
    public modalRef: ModalService;

    protected cmsService: CmsService = inject(CmsService);

    public ngOnInit(): void {
        this.isDarwin = this.plan.data.is_darwin;

        const dataEnvelope = this.plan.data.data_envelope.replace(/ /g, '_').replace(/à/g, 'a').toLowerCase();
        this.cmsService.getPlanDetails(this.plan.gencode, dataEnvelope, false).subscribe((data) => {
            this.planDetails = {
                ...data,
                text_popin: markdownTrilogy(data.text_popin),
            };
        });

        if (this.isDarwin) {
            this.title = 'Le forfait qui grandit avec votre ado...';
        } else {
            this.title = this.plan.data?.low_prices_wall
                ? "L'essentiel pour bien communiquer..."
                : 'Le plein de gigas, mais pas seulement...';
        }
    }

    public close(): void {
        this.modalRef.close();
    }

    public add: () => void = () => {
        this.addPlan();
        this.close();
    };

    public lockedToggle(): void {
        this.isLocked = !this.isLocked;
        this.lockedToggleEvent.emit(this.isLocked);
    }

    public toggleInternationalCall(value: boolean): void {
        this.showInternationalCallsList = value;
    }

    public toggleEuropeSmsMmsList(value: boolean): void {
        this.showEuropeSmsMmsList = value;
    }

    public toggleEuropeAbroadList(value: boolean): void {
        this.showEuropeAbroadList = value;
    }
}
